var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgVideoStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.953,
    height: 70.003,
    viewBox: "0 0 43.953 70.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11421",
    "data-name": "Group 11421",
    transform: "translate(-782.229 -8490.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11420",
    "data-name": "Group 11420",
    transform: "translate(785.732 8493.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37169",
    "data-name": "Path 37169",
    d: "M9.179,62.83V61.381c0-7.423-.01-14.847.008-22.27a3.8,3.8,0,0,1,7.487-1.181,9.064,9.064,0,0,1,.17,1.887q.019,7.778.007,15.556v1.6c1.122-1.888,2.461-2.876,4.427-2.555,1.948.318,2.9,1.647,3.295,3.555,1.971-3.514,6.573-3.447,7.75,1.178.178-.255.321-.462.466-.669a3.66,3.66,0,0,1,3.891-1.649,3.3,3.3,0,0,1,3.012,3.05c.091,5.651.846,11.367-.508,16.938-2.01,8.27-9.705,13.682-18.476,13.28A17.818,17.818,0,0,1,4.155,75.137a57.819,57.819,0,0,1-.239-9.044A3.365,3.365,0,0,1,7.4,62.834c.551-.024,1.1,0,1.777,0",
    transform: "translate(-2.984 -27.118)",
    fill: "#fff",
    stroke: "#7833ba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37170",
    "data-name": "Path 37170",
    d: "M2.49,16.606C-1.1,13.1-.713,6.533,3.045,2.893a10.2,10.2,0,0,1,14.662.44c3.456,3.752,3.517,10.31.007,13.418-.036-.4-.084-.719-.088-1.034-.017-1.468.033-2.94-.041-4.4a7.5,7.5,0,0,0-7.528-7.078A7.487,7.487,0,0,0,2.5,11.4c-.067,1.64-.011,3.286-.011,5.207",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#7833ba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1641",
    "data-name": "Group 1641",
    transform: "translate(785.732 8493.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37169-2",
    "data-name": "Path 37169",
    d: "M9.179,62.83V61.381c0-7.423-.01-14.847.008-22.27a3.8,3.8,0,0,1,7.487-1.181,9.064,9.064,0,0,1,.17,1.887q.019,7.778.007,15.556v1.6c1.122-1.888,2.461-2.876,4.427-2.555,1.948.318,2.9,1.647,3.295,3.555,1.971-3.514,6.573-3.447,7.75,1.178.178-.255.321-.462.466-.669a3.66,3.66,0,0,1,3.891-1.649,3.3,3.3,0,0,1,3.012,3.05c.091,5.651.846,11.367-.508,16.938-2.01,8.27-9.705,13.682-18.476,13.28A17.818,17.818,0,0,1,4.155,75.137a57.819,57.819,0,0,1-.239-9.044A3.365,3.365,0,0,1,7.4,62.834c.551-.024,1.1,0,1.777,0",
    transform: "translate(-2.984 -27.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37170-2",
    "data-name": "Path 37170",
    d: "M2.49,16.606C-1.1,13.1-.713,6.533,3.045,2.893a10.2,10.2,0,0,1,14.662.44c3.456,3.752,3.517,10.31.007,13.418-.036-.4-.084-.719-.088-1.034-.017-1.468.033-2.94-.041-4.4a7.5,7.5,0,0,0-7.528-7.078A7.487,7.487,0,0,0,2.5,11.4c-.067,1.64-.011,3.286-.011,5.207",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgVideoStep2);
export default __webpack_public_path__ + "static/media/img_video_step_2.c82b42499d94ad03ad051770d693e745.svg";
export { ForwardRef as ReactComponent };